const constants = require("domuso-constants");
const {
  PaymentSourceTypes,
} = constants.payment;

export const isPersonalCheckAllowed = ({ certifiedStartDay, certifiedEndDay}: any) => {
  const currentDate = new Date().getDate();
  const isWithinCertifiedDateRange = (Boolean(certifiedStartDay) && currentDate >= certifiedStartDay) && (Boolean(certifiedEndDay) && currentDate <= certifiedEndDay);
  return !isWithinCertifiedDateRange;
};

export const accountNumberFormat = (type, lastFour) => {
  let payload = "**** ****";

  if(type == PaymentSourceTypes.BANK_ACCOUNT){
    payload = `**** ${lastFour}`;
  }

  if(type == PaymentSourceTypes.CREDIT_CARD){
    payload = `**** **** **** ${lastFour}`;
  }

  return payload;
};